import { render, staticRenderFns } from "./EntradaCreate.vue?vue&type=template&id=415fab20&scoped=true"
import script from "./EntradaCreate.vue?vue&type=script&lang=js"
export * from "./EntradaCreate.vue?vue&type=script&lang=js"
import style0 from "./EntradaCreate.vue?vue&type=style&index=0&id=415fab20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415fab20",
  null
  
)

export default component.exports